export default __webpack_public_path__ + "static/media/rm2.d249f74b.png";